import React from "react";

export const CancellationSchedule: React.FunctionComponent = (props) => {
  return <>Cancellation Schedule</>;
};
